import { useEffect, useRef } from 'react';
/**
 * Hook to create a callback that is triggered after {delay} seconds when called
 */
export const useDelayCallback = (callback, delay, dep = []) => {
    const timeoutId = useRef(null);
    // Clear setTimeout and remove timeoutId
    const cleanup = () => {
        if (!!timeoutId.current) {
            window.clearTimeout(timeoutId.current);
            timeoutId.current = null;
        }
    };
    // Cleanup and call the function in delay second
    const delayedCallback = () => {
        cleanup();
        timeoutId.current = window.setTimeout(callback, delay);
    };
    // Clean up when component unmount or dependencies change
    useEffect(() => cleanup, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [...dep, delay]);
    return delayedCallback;
};
//# sourceMappingURL=useDelayCallback.preenvesnextjs.map
